var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "explain-block block" }, [
    _c("div", { staticClass: "block-title" }, [
      _c("div", { staticClass: "dot" }),
      _vm._v(" " + _vm._s(_vm.$t("invention.explain.title[0]")) + " "),
    ]),
    _c("div", { staticClass: "video" }, [
      _vm.content
        ? _c("iframe", {
            staticClass: "video-frame",
            attrs: {
              src: _vm.getVideo(_vm.content.video),
              title: "YouTube video player",
              frameborder: "0",
              allow:
                "accelerometer; autoplay; clipboard-write;\n        encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: "",
            },
          })
        : _vm._e(),
    ]),
    _c("div", { staticClass: "sub-block" }, [
      _c("div", { staticClass: "sub-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("invention.explain.title[1]")) + " "),
      ]),
      _c(
        "div",
        { staticClass: "block-content" },
        [_c("content-renderer", { attrs: { content: _vm.content.purpose } })],
        1
      ),
    ]),
    _c("div", { staticClass: "sub-block" }, [
      _c("div", { staticClass: "sub-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("invention.explain.title[2]")) + " "),
        _c("div", { staticClass: "title-tips" }, [
          _vm._v(" " + _vm._s(_vm.$t("invention.explain.tips")) + " "),
        ]),
      ]),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "block-content theme" }, [
      _c("img", {
        staticClass: "theme-image",
        attrs: { src: require("../../assets/invention/theme.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }